import { Component, ViewChild } from '@angular/core';
import { environment } from '../../../environments/environment';
import { CommonModule } from '@angular/common';
import { NoticiaService } from '../../services/noticia/noticia.service';
import { RouterModule, Router } from '@angular/router';
import { NgbCarousel, NgbCarouselModule, NgbSlideEvent, NgbSlideEventSource } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-banner',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterModule, NgbCarousel, NgbCarouselModule],
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.scss'
})
export class BannerComponent {
  @ViewChild('carousel', { static: true })
  carousel!: NgbCarousel;
  imagemBanner: string = environment.imagemBanner;
  items: any;
  paused = false;
  unpauseOnArrow = false;
  pauseOnIndicator = false;
  pauseOnHover = true;
  pauseOnFocus = true;
  banners: any[] = [];
  isLoading = false;

  constructor(private router: Router, private noticiaService: NoticiaService) {}

  ngOnInit(): void {
    this.getBanners();
  }

  togglePaused() {
    if (this.paused) {
      this.carousel.cycle();
    } else {
      this.carousel.pause();
    }
    this.paused = !this.paused;
  }

  onSlide(slideEvent: NgbSlideEvent) {
    if (
      this.unpauseOnArrow &&
      slideEvent.paused &&
      (slideEvent.source === NgbSlideEventSource.ARROW_LEFT || 
      slideEvent.source === NgbSlideEventSource.ARROW_RIGHT)
    ) {
      this.togglePaused();
    }
    if (this.pauseOnIndicator && !slideEvent.paused && slideEvent.source === NgbSlideEventSource.INDICATOR) {
      this.togglePaused();
    }
  }

  getBanners() {
    this.isLoading = true;
    this.noticiaService.getBanners().subscribe(
      (res) => {
        console.log('Formato Arquivos:', res.formatoArquivos);

        this.items = res.formatoArquivos.map((noticia: any) => ({
          titulo: noticia.nomePublicacao,
          imagem: noticia.binPublicacao ? noticia.binPublicacao : '',
          subtitulo: noticia.dscPublicacao,
          urlBin: noticia.urlBin,
        }));

        this.updateBanners();
        this.isLoading = false;
      },
      (error) => {
        this.isLoading = false;
        console.error('Erro ao buscar noticias:', error);
      }
    );
  }

  updateBanners() {
    this.banners = this.items;
  }
  
  item = {
    name: 'eicon',
    icon: '/assets/svg/eicon.svg'
  }
}
